export const isAuthenticated = state => {
    
    return localStorage.getItem('accessToken') !== null

}

export const getAllMenus = state => {
    
    let menus = state.menus.menus

    return menus
}

export const getMenus = state => {

    let menus = state.menus.menus

    return menus
}

export const getCurrentPathProps = state => {
    return state.authModal.currentPathProps
}

export const getUserauthResponse = state => {
    return state.authResponse
}

export const getAccessibleBranches = state => {
    return state.authResponse.accessible_branches
}

export const getReligions = state => {
    return state.general.religion
}

export const getCountries = state => {
    return state.general.countries
}

export const getRelations = state => {
    return state.general.relations
}

export const getReminders = state => {
    return state.reminders
}

export const getDashboardValues = state => {
    return state.dashboard
}

export const getAdminStatus = state => {
    return state.authResponse.admin
}

export const getDashboardProps = state => {
    return state.dashboardProps
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js